<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('create')">
                <img src="@/assets/image/addAccount.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('menuMgt.createMenu') }}
            </a-button>
        </div>

        <a-tabs v-model:activeKey="activeKey" @change="handleChangeTab">
            <a-tab-pane key="0">
                <template #tab>
                    <span><appstore-outlined />{{ $t('menuMgt.page') }}</span>
                </template>
            </a-tab-pane>
            <!-- <a-tab-pane key="1">
                <template #tab>
                    <span><playCircle-outlined />{{ $t('menuMgt.button') }}</span>
                </template>
            </a-tab-pane> -->
            <a-tab-pane key="2">
                <template #tab>
                    <span><codeSandbox-outlined />{{ $t('menuMgt.businessFun') }}</span>
                </template>
            </a-tab-pane>
            <a-tab-pane key="3">
                <template #tab>
                    <span><api-outlined />{{ $t('menuMgt.interface') }}</span>
                </template>
            </a-tab-pane>
        </a-tabs>

        <div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
            >
                <!-- <template v-slot:customCol="{props}"></template> -->

                <!-- 父表格操作按钮 -->
                <template v-slot:tableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" size="small" style="margin-right:10px" @click="handle('edit',props.record)">
                            {{ $t('role.edit') }}
                        </a-button>
                        <a-button size="small" @click="handle('delete',props.record)">
                            {{ $t('role.delete') }}
                        </a-button>
                    </template>
                </template>
            </Table>
        </div>


        <a-modal 
            v-model:open="visible"
            :closable="false"
            :width="550"
            centered
            :maskClosable="false"
            :okText="t('base.confirm')"
            :cancelText="t('base.cancel')"
            @ok="addMenu"
            @cancel="visible = false"
        >
            <div class="modal_title">{{ modal_title }}</div>

            <div class="form">
                <div class="form_item">
                    <div class="form_item_label">{{ $t('menuMgt.menuType') }} <span class="required">*</span> </div>
                    <div>
                        <a-space direction="vertical">
                            <a-radio-group 
                                v-model:value="formData.menu_type" 
                                :options="menuTypeOptions" 
                                @change="handleChangeMenuType" 
                            />
                        </a-space>
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0'">
                    <div class="form_item_label">{{ $t('menuMgt.menuCategory') }} <span class="required">*</span></div>
                    <div>
                        <a-select
                            ref="select"
                            v-model:value="formData.menu_category"
                            style="width: 100%;"
                            allowClear
                        >
                            <a-select-option :value="0">{{ $t('menuMgt.backend') }}</a-select-option>
                            <a-select-option :value="1">{{ $t('menuMgt.serviceTool') }}</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="form_item">
                    <div class="form_item_label">{{ $t('menuMgt.menuName') }} <span class="required">*</span> </div>
                    <div>
                        <a-input 
                            v-model:value="formData.menu_name"
                            :maxlength="70"
                            allowClear
                        />
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0'">
                    <div class="form_item_label">{{ $t('menuMgt.menuPath') }} <span class="required">*</span></div>
                    <div>
                        <a-input 
                            v-model:value="formData.menu_path"
                            :maxlength="70"
                            allowClear
                        />
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0'">
                    <div class="form_item_label">{{ $t('menuMgt.menuLevel') }} <span class="required">*</span></div>
                    <div>
                        <a-select
                            ref="select"
                            v-model:value="formData.menu_level"
                            style="width: 100%;"
                            allowClear
                            @change="(e)=>handleChangeMenuLevel(e)"
                        >
                            <a-select-option value="1">1</a-select-option>
                            <a-select-option value="2">2</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0' || formData.menu_type == '1' || formData.menu_type == '2'">
                    <div class="form_item_label">{{ $t('menuMgt.menuParent') }} <span class="required">*</span></div>
                    <div>
                        <a-select
                            ref="select"
                            v-model:value="formData.menu_parent"
                            style="width: 100%;"
                            allowClear
                            :options="menuParentList"
                        ></a-select>
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0'">
                    <div class="form_item_label">{{ $t('menuMgt.menuIndex') }} <span class="required">*</span></div>
                    <div>
                        <a-input-number 
                            v-model:value="formData.menu_index"
                            :controls="false"
                            :min="0"
                            style="width: 100%;"
                        />
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '0'">
                    <div class="form_item_label">{{ $t('menuMgt.menuIcon') }}</div>
                    <div>
                        <a-input 
                            v-model:value="formData.menu_icon"
                            allowClear
                        />
                    </div>
                </div>
                <!-- 仅页面、功能点显示 -->
                <div class="form_item" v-if="formData.menu_type == '0' || formData.menu_type == '2'">
                    <div class="form_item_label">{{ $t('menuMgt.tenantDisplay') }}</div>
                    <div>
                        <a-switch v-model:checked="formData.tenant_display" />
                    </div>
                </div>
                <!-- 仅接口权限显示 -->
                <div class="form_item" v-if="formData.menu_type == '3'">
                    <div class="form_item_label">{{ $t('menuMgt.menuUrl') }} <span class="required">*</span></div>
                    <div>
                        <a-input 
                            v-model:value="formData.menu_url"
                            :maxlength="70"
                            allowClear
                        />
                    </div>
                </div>
                <div class="form_item" v-if="formData.menu_type == '3'">
                    <div class="form_item_label">{{ $t('menuMgt.menuMethod') }} <span class="required">*</span></div>
                    <div>
                        <a-select
                            ref="select"
                            v-model:value="formData.menu_method"
                            style="width: 100%;"
                            allowClear
                        >
                            <a-select-option value="GET">GET</a-select-option>
                            <a-select-option value="POST">POST</a-select-option>
                            <a-select-option value="PUT">PUT</a-select-option>
                            <a-select-option value="DELETE">DELETE</a-select-option>
                            <a-select-option value="PATCH">PATCH</a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
        </a-modal>

    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate } from '@/utils/global';
    import { MenuApi } from '@/api/MenuApi.js';
    import Mock from '@/layouts/mock.json'

    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()


    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const rowData = ref(null)
    const form_disabled = ref(false)
    const operate_type = ref('create')
    const modal_title = ref(t('menuMgt.createMenu'))
    const mockData = ref([])
    const menuList = ref([])
    const menuParentList = ref([])
    const activeKey = ref('0')

    const headerData = ref({
        menu:'menu.Menu',
        menu_desc: 'menu.subMenuMTG',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const formData = reactive({
        menu_type:'',
        menu_category:'',
        menu_name:'',
        menu_path:'',
        menu_level:'',
        menu_parent:'',
        menu_index:'',
        menu_url:'',
        menu_method:'',
        menu_icon:'',
        tenant_display:'',
    })

    const page_field_required = reactive({
        menu_type: t('menuMgt.menuType') +' ' + t('base.noEmpty'),
        menu_category: t('menuMgt.menuCategory') +' ' + t('base.noEmpty'),
        menu_name: t('menuMgt.menuName') +' ' + t('base.noEmpty'),
        menu_path: t('menuMgt.menuPath') +' ' + t('base.noEmpty'),
        menu_level: t('menuMgt.menuLevel') +' ' + t('base.noEmpty'),
        menu_parent: t('menuMgt.menuParent') +' ' + t('base.noEmpty'),
        menu_index: t('menuMgt.menuIndex') +' ' + t('base.noEmpty'),
    })

    const fun_field_required = reactive({
        menu_name: t('menuMgt.menuName') +' ' + t('base.noEmpty'),
        menu_parent: t('menuMgt.menuParent') +' ' + t('base.noEmpty'),
        tenant_display: t('menuMgt.tenantDisplay') +' ' + t('base.noEmpty'),
    })

    const interface_field_required = reactive({
        menu_name: t('menuMgt.menuName') +' ' + t('base.noEmpty'),
        menu_url: t('menuMgt.menuUrl') +' ' + t('base.noEmpty'),
        menu_method: t('menuMgt.menuMethod') +' ' + t('base.noEmpty'),
    })

    const menuTypeOptions = ref([
        {
            label: t('menuMgt.page'),
            value: '0',
            disabled: false,
        },
        // {
        //     label: t('menuMgt.button'),
        //     value: '1',
        //     disabled: false,
        // },
        {
            label: t('menuMgt.businessFun'),
            value: '2',
            disabled: false,
        },
        {
            label: t('menuMgt.interface'),
            value: '3',
            disabled: false,
        },
    ])

    const page_columns = ref(
        [
            {
                title: t('menuMgt.menuName'),
                dataIndex: 'menu_name_text',
                key: 'menu_name_text',
                width: 240,
            },
            {
                title: t('menuMgt.menuKey'),
                dataIndex: 'menu_key',
                key: 'menu_key',
                width: 240,
            },
            {
                title: t('menuMgt.menuPath'),
                dataIndex: 'menu_path',
                key: 'menu_path',
                width: 280,
            },
            {
                title: t('menuMgt.menuLevel'),
                dataIndex: 'menu_level_text',
                key: 'menu_level_text',
                width: 130,
                filters: [
                    {
                        text: t('menuMgt.menuLevel1'),
                        value: t('menuMgt.menuLevel1'),
                    },
                    {
                        text: t('menuMgt.menuLevel2'),
                        value: t('menuMgt.menuLevel2'),
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.menu_level_text.indexOf(value) === 0,
            },
            {
                title: t('menuMgt.menuIndex'),
                dataIndex: 'menu_index',
                key: 'menu_index',
                width: 130,
            },
            {
                title: t('menuMgt.menuParent'),
                dataIndex: 'menu_parent',
                key: 'menu_parent',
                width: 130,
            },
            {
                title: t('menuMgt.menuId'),
                dataIndex: 'id',
                key: 'id',
                width: 100,
            },
            {
                title: t('menuMgt.menuCategory'),
                dataIndex: 'menu_category_text',
                key: 'menu_category_text',
                width: 160,
                filters: [
                    {
                        text: t('menuMgt.backend'),
                        value: t('menuMgt.backend'),
                    },
                    {
                        text: t('menuMgt.serviceTool'),
                        value: t('menuMgt.serviceTool'),
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.menu_category_text.indexOf(value) === 0,
            },
            {
                title: t('menuMgt.tenantDisplay'),
                dataIndex: 'tenant_display_text',
                key: 'tenant_display_text',
                width: 150,
                filters: [
                    {
                        text: t('base.yes'),
                        value: t('base.yes'),
                    },
                    {
                        text: t('base.no'),
                        value: t('base.no'),
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.tenant_display_text.indexOf(value) === 0,
            },
            {
                title: t('menuMgt.menuIcon'),
                dataIndex: 'menu_icon',
                key: 'menu_icon',
                width: 160,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            },
        ]
    )

    const button_columns = ref(
        [
            {
                title: t('menuMgt.menuName'),
                dataIndex: 'menu_name',
                key: 'menu_name',
                width: 240,
            },
            {
                title: t('menuMgt.menuParent'),
                dataIndex: 'menu_parent',
                key: 'menu_parent',
                width: 180,
            },
            {
                title: t('menuMgt.menuId'),
                dataIndex: 'id',
                key: 'id',
                width: 180,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            },
        ]       
    )

    const fun_columns = ref(
        [
            {
                title: t('menuMgt.menuName'),
                dataIndex: 'menu_name_text',
                key: 'menu_name_text',
                width: 240,
            },
            {
                title: t('menuMgt.menuKey'),
                dataIndex: 'menu_key',
                key: 'menu_key',
                width: 240,
            },
            {
                title: t('menuMgt.tenantDisplay'),
                dataIndex: 'tenant_display_text',
                key: 'tenant_display_text',
                width: 180,
            },
            {
                title: t('menuMgt.menuParent'),
                dataIndex: 'menu_parent',
                key: 'menu_parent',
                width: 180,
            },
            {
                title: t('menuMgt.menuId'),
                dataIndex: 'id',
                key: 'id',
                width: 180,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            },
        ]       
    )

    const interface_columns = ref(
        [
            {
                title: t('menuMgt.menuName'),
                dataIndex: 'menu_name',
                key: 'menu_name',
                width: 240, 
            },
            {
                title: t('menuMgt.menuUrl'),
                dataIndex: 'menu_url',
                key: 'menu_url',
                width: 280, 
            },
            {
                title: t('menuMgt.menuMethod'),
                dataIndex: 'menu_method',
                key: 'menu_method',
                width: 180, 
                filters: [
                    {
                        text: 'GET',
                        value: 'GET',
                    },
                    {
                        text: 'POST',
                        value: 'POST',
                    },
                    {
                        text: 'PUT',
                        value: 'PUT',
                    },
                    {
                        text: 'PATCH',
                        value: 'PATCH',
                    },
                    {
                        text: 'DELETE',
                        value: 'DELETE',
                    },
                ],
                filterMultiple: false,
                onFilter: (value, record) => record.menu_method.indexOf(value) === 0,
            }, 
            {
                title: t('menuMgt.menuId'),
                dataIndex: 'id',
                key: 'id',
                width: 180,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            }, 
        ]       
    )

    const table = ref({
        data: [],
        columns: page_columns.value,
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                showSizeChanger: true,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handleChangeTab = (key)=>{
        console.log(key, 'key', activeKey.value)
        activeKey.value = key
        switch(key){
            case '0':
                table.value.columns = page_columns.value
                break;
            case '1':
                table.value.columns = button_columns.value
                break;
            case '2':
                table.value.columns = fun_columns.value
                break;
            case '3':
                table.value.columns = interface_columns.value
                break;
        } 
        table.value.configs.pagination.current = 1
        getMenuList()  
    }

    const handle = (type , row)=>{
        switch(type){
            case 'create': // 创建菜单
                visible.value = true
                operate_type.value = 'create'
                modal_title.value = t('menuMgt.createMenu')  
                
                menuTypeOptions.value.forEach(item => {
                    item.disabled = false
                })
                for(let key in formData){
                    formData[key] = ''
                }
                formData.menu_type = '0'
                form_disabled.value = false
                break;
            case 'delete': // 删除菜单
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('role.deleteTip'),
                    okText: t('base.ok'),
                    cancelText: t('base.cancel'),
                    onOk:()=>{
                        deleteMenu(row)
                    },
                });
                break;
            case 'edit': // 编辑角色
                visible.value = true
                operate_type.value = 'edit'
                modal_title.value = t('menuMgt.editMenu')
                menuTypeOptions.value.forEach(item => {
                    item.disabled = item.value != row.menu_type
                })

                rowData.value = row
                if(row.menu_type == '0'){
                    handleChangeMenuLevel(row.menu_level)
                }else if(row.menu_type == '1' || row.menu_type == '2'){
                    menuParentList.value = menuList.value.filter(item => item.level != 0)
                }
                
                formData.menu_type = activeKey.value
                formData.menu_category = row.menu_category == '-' ? '' : row.menu_category
                formData.menu_name = row.menu_name == '-' ? '' : row.menu_name
                formData.menu_path = row.menu_path == '-' ? '' : row.menu_path
                formData.menu_index = row.menu_index == '-' ? '' : row.menu_index
                formData.menu_parent = row.menu_parent == '-' ? '' : row.menu_parent
                formData.menu_level = row.menu_level == '-' ? '' : row.menu_level
                formData.menu_url = row.menu_url == '-' ? '' : row.menu_url
                formData.menu_method = row.menu_method == '-' ? '' : row.menu_method
                formData.menu_icon = row.menu_icon == '-' ? '' : row.menu_icon
                formData.tenant_display = row.tenant_display == '-'? '' : row.tenant_display === 0 
                break;
        }
    }

    // 分页
    const handleChangePagination =  (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getMenuList()
    } 

    // 校验
    const vaild = ()=>{
        console.log(formData.menu_type, 'formData.menu_type')
        switch(formData.menu_type){
            case '0':
                let field_arr = ['menu_type','menu_url','menu_method','menu_icon','tenant_display']
                for(const key in formData){
                    if(!field_arr.includes(key) && formData[key] === ''){
                        message.error(page_field_required[key])
                        return false
                    }
                }
                break;
            case '2':
                let field_arr2 = ['menu_category','menu_path','menu_level','menu_index','menu_url','menu_method','menu_icon','tenant_display']
                for(const key in formData){
                    if(!field_arr2.includes(key) && formData[key] === ''){
                        message.error(fun_field_required[key])
                        return false
                    }
                }               
                break;
            case '3':
                let field_arr3 = ['menu_category','menu_parent','menu_path','menu_level','menu_index','menu_icon','tenant_display']
                for(const key in formData){
                    if(!field_arr3.includes(key) && formData[key] === ''){
                        message.error(interface_field_required[key])
                        return false
                    }
                }               
                break;
        }

        return true
    }

    // 创建/编辑 菜单
    const addMenu = async()=>{
        if(!vaild()) return

        let param = {
            ...formData, // 0:创建   1：添加
            menu_parent: formData.menu_type == 3? null : formData.menu_parent,
            tenant_display: formData.menu_type == 3? '' : formData.tenant_display? 0 : 1
        }
        let res = operate_type.value == 'create' 
                ? await MenuApi.getInstance().addMenu(param) 
                : await MenuApi.getInstance().editMenu(param, rowData.value.id)

        if(res.code === 0){
            visible.value = false
            table.value.configs.pagination.current = 1
            getMenuList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 选择菜单类别
    const handleChangeMenuType = ()=>{
        console.log(formData.menu_type, 'formData.menu_type')
        for(let key in formData){
            if(key !== 'menu_type'){
                formData[key] = ''
            }
        }
        menuParentList.value = []

        if(formData.menu_type == '1' || formData.menu_type == '2'){
            menuParentList.value = menuList.value.filter(item => item.level != 0)
        }
        
    }

    // 选择菜单级别
    const handleChangeMenuLevel = (val)=>{
        console.log(val, 'e')
        if(!val){
            formData.menu_parent = ''
        }else if(val == 1){ 
            menuParentList.value = menuList.value.filter(item => item.level == 0)
            formData.menu_parent = 0
        }else if(val == 2){
            menuParentList.value = menuList.value.filter(item => item.level == 1)
            formData.menu_parent = ''
        }
    }

    // 菜单列表
    const getMenuList = async()=>{
        let param = {
            menu_type: activeKey.value,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await MenuApi.getInstance().getMenuList(param,page_num,page_size)
        if(res.code === 0){
            table.value.configs.loading = false
            res.data.records.forEach(item => {
                item.menu_name_text = item.menu_name == undefined ? '-' : t(item.menu_name) 
                item.menu_name = item.menu_name
                item.menu_key = item.menu_name == undefined ? '-' : item.menu_name
                item.menu_level_text = item.menu_level == 1? t('menuMgt.menuLevel1') : item.menu_level == 2? t('menuMgt.menuLevel2') : t('menuMgt.menuLevel3')
                item.menu_icon = item.menu_icon == '' ? '-' : item.menu_icon
                item.menu_category_text = item.menu_category == 0 ? t('menuMgt.backend') : t('menuMgt.serviceTool')
                item.tenant_display_text = item.tenant_display === 0? t('base.yes') : t('base.no')
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 菜单下拉数据
    const getMenuSelectList = async()=>{
        let param = {
            menu_type: 0,
        }
        let res = await MenuApi.getInstance().getMenuSelectList(param)
        if(res.code === 0){
            menuList.value = [{
                label: t('menuMgt.menuTop'),
                value: 0,
                level: 0,
            }]
            res.data.forEach(item => {
                menuList.value.push({
                    label: t(`${item.menu_name}`) ,
                    value: item.id,
                    level: item.menu_level,
                })
            })
            menuList.value = menuList.value.reverse()
            console.log(menuList.value, 'menuList')
        }else{
            message.error(res.msg || res.message)
        }
    }   


    // 删除菜单
    const deleteMenu = async(row)=>{
        let res = await MenuApi.getInstance().deleteMenu(row.id)
        if(res.code === 0){
            message.success(res.msg)
            table.value.configs.pagination.current = 1
            getMenuList()
        }else{
            message.error(res.msg || res.message)
        }
    }   


    onMounted(()=>{
        getMenuList()
        getMenuSelectList()
    })

</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: 30px;
}


.form{
    .form_item{
        margin-bottom: 15px;

        .form_item_label{
            font-size: 16px;
            font-weight: 600;
        }

        .required{
            color: red;
        }
    }
}

.modal_title{
    margin-bottom: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}

</style>